import { idleState, uninitState, failedState, loadingState, successState } from "@grandvisionhq/state";
import { UPDATE_OPT_INS_FAILED, UPDATE_OPT_INS_SUCCESS, UPDATE_OPT_INS, TOGGLE_OPT_INS, FETCH_OPT_INS_FAILED, FETCH_OPT_INS_SUCCESS, FETCH_OPT_INS } from "./actions.js";
const initialState = {
  optInsOnServer: uninitState(),
  changedOptIns: {},
  updateOptInsCall: idleState()
};
function optInsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_OPT_INS:
      return {
        ...state,
        optInsOnServer: loadingState()
      };
    case FETCH_OPT_INS_SUCCESS:
      return {
        ...state,
        optInsOnServer: successState(action.payload)
      };
    case FETCH_OPT_INS_FAILED:
      return {
        ...state,
        optInsOnServer: failedState(action.error)
      };
    case TOGGLE_OPT_INS:
      return {
        ...state,
        changedOptIns: {
          ...state.changedOptIns,
          ...action.payload
        }
      };
    case UPDATE_OPT_INS:
      return {
        ...state,
        updateOptInsCall: loadingState()
      };
    case UPDATE_OPT_INS_SUCCESS:
      return {
        ...state,
        updateOptInsCall: idleState()
      };
    case UPDATE_OPT_INS_FAILED:
      return {
        ...state,
        updateOptInsCall: failedState(action.error)
      };
    default:
      return state;
  }
}
export {
  initialState,
  optInsReducer
};
//# sourceMappingURL=reducer.js.map
